import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ScheduleCollectiveEditTemplate } from 'components/Templates'

const ScheduleCollectiveEdit: FC = () => {
  return (
    <Layout title={'商品の受渡日を一括設定'}>
      <ScheduleCollectiveEditTemplate />
    </Layout>
  )
}

export default ScheduleCollectiveEdit
